// extracted by mini-css-extract-plugin
export default {"heroSection":"dream_heroSection__eVweE","heroOverlay":"dream_heroOverlay__NhjL-","heroText":"dream_heroText__pZu2W","fadeInUp":"dream_fadeInUp__TD2lY"};